import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatRelativeTime } from "components/SmartSurveyor/SmartSurveyorV3/HistoryDrawer/utils/formatRelativeTime";
import type { UseMarkerNoteByline } from "./types";

export const useMarkerNoteByline: UseMarkerNoteByline = ({ note }) => {
  const { t, i18n } = useTranslation();

  // An edited note shows only when it was last edited; there is no room for both times.
  const isEdited = note.updatedAt !== note.createdAt;

  // On the plan every pan re-renders the card; this only changes with the note or the language.
  const timeLabel = useMemo(() => {
    const ago = formatRelativeTime({
      isoDate: isEdited ? note.updatedAt : note.createdAt,
      now: new Date(),
      locale: i18n.language,
    });
    return isEdited
      ? t("smartSurveyor.elementDetails.note.editedAt", { date: ago })
      : ago;
  }, [isEdited, note.createdAt, note.updatedAt, i18n.language, t]);

  return {
    author: note.createdBy ?? t("smartSurveyor.history.admin"),
    timeLabel,
  };
};
